import { allDoctypes, nfuDocs, doctypeTranslations } from "./document";
import { allFileTypes, filetypeTranslations } from "./dossiers";
import { allRoles, allRolesLabels } from "./roles";
import { combineReducers } from "redux";
import { allGroups, allRelations, relationReducer, userdataReducer, userrightsReducer } from "./users";
import { localizationContent } from "./content";

const allReducers = combineReducers({
    content: localizationContent,
    doctypes: allDoctypes,
    doctypesTranslations: doctypeTranslations,
    filetypes: allFileTypes,
    filetypesTranslations: filetypeTranslations,
    roles: allRoles,
    roleslabels: allRolesLabels,
    nfuDocs: nfuDocs,
    allRelations: allRelations,
    allGroups: allGroups,
    relation: relationReducer,
    userRights: userrightsReducer,
    userdata: userdataReducer
})

export default allReducers;